import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import CategoryIcon from "@/components/CategoryIcon";
import { CATEGORIES } from "@/data/constants";
import { ArrowRight } from "lucide-react";

export default function Categories() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-gray-900">Categories</h1>
      <p className="mt-4 text-lg text-gray-700 max-w-2xl">Every venue on Access Local belongs to one of six clear categories, each with its own inspection framework.</p>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {CATEGORIES.map(c => (
          <Link key={c.slug} to={`/search?category=${c.slug}`} data-testid={`category-page-${c.slug}`}>
            <Card className="bg-white border border-gray-200 hover:border-gray-900 transition-colors duration-200 rounded-xl">
              <CardContent className="p-8 flex items-start gap-5">
                <div className="w-14 h-14 rounded-xl bg-gray-900 text-white flex items-center justify-center">
                  <CategoryIcon slug={c.slug} className="w-7 h-7"/>
                </div>
                <div>
                  <h3 className="font-heading text-2xl font-semibold text-gray-900">{c.name}</h3>
                  <p className="mt-2 text-gray-700">{c.blurb}</p>
                  <div className="mt-3 inline-flex items-center gap-1 text-blue-700 font-medium">Browse venues <ArrowRight className="w-4 h-4"/></div>
                </div>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
